import { useEffect, useRef, useCallback } from "react";
import { createTour, hasSeenTour } from "./tourConfig";

const useTour = (tourName, steps, isReady = true) => {
  const tourRef = useRef(null);
  const hasAutoTriggered = useRef(false);

  // Auto-trigger on first visit
  useEffect(() => {
    if (!isReady || hasAutoTriggered.current || hasSeenTour(tourName)) return;

    hasAutoTriggered.current = true;

    const timer = setTimeout(() => {
      const instance = createTour(tourName, steps);
      if (instance) {
        tourRef.current = instance;
        instance.drive();
      }
    }, 800);

    return () => clearTimeout(timer);
  }, [tourName, steps, isReady]);

  // Manual replay
  const startTour = useCallback(() => {
    if (tourRef.current) {
      try { tourRef.current.destroy(); } catch (e) { /* noop */ }
    }

    const instance = createTour(tourName, steps);
    if (instance) {
      tourRef.current = instance;
      instance.drive();
    }
  }, [tourName, steps]);

  return { startTour };
};

export default useTour;
